import { render } from "./RadioGroup.vue?vue&type=template&id=4e904e23&scoped=true"
import script from "./RadioGroup.vue?vue&type=script&lang=js"
export * from "./RadioGroup.vue?vue&type=script&lang=js"

import "./RadioGroup.vue?vue&type=style&index=0&id=4e904e23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e904e23"]])

export default __exports__